import React, { useState } from 'react'
import { ButtonDropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { CloseIcon, FilterIcon, filterBlackIcon } from '../../../../assets/images';
import { RadioTypes } from '../../../../commonTypes/universalTypes';
import Select from "react-select";
import { ClientListType } from '../../../../screens/Scheduling/ScheduleReports/AllClientsSchedule';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

type AppProps = {
  clientSelected: ClientListType;
  finalClientList: ClientListType[] | [];
  handleChangeClient: (data: any) => void;
  checkBottom: (data: any) => void;
  setLoadCondition: (data: boolean) => void;
  setText: (data: string) => void;
  setOffset: (data: number) => void;
  clientDirectoryFetching: boolean;
  onMenuClose: () => void;
  loadCondition: boolean;
  handleFilter: (type: string) => void;
  setClientSelected: (data: ClientListType) => void;
  filter: number | null | undefined;
  setFilter: (data: number | null | undefined) => void;
}


const AllClientScheduleFilter = ({
  clientSelected,
  finalClientList,
  handleChangeClient,
  checkBottom,
  setLoadCondition,
  clientDirectoryFetching,
  onMenuClose,
  setText,
  setOffset,
  handleFilter,
  loadCondition,
  setClientSelected,
  filter,
  setFilter
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);

  const handleSubmit = () => {
    if (!!clientSelected?.value && filter != clientSelected?.value) {
      handleFilter("add")
      setOffset(0);
    }
  };

  const clearFilter = () => {
    setOffset(0);
    handleChangeClient("")
    setClientSelected({
      value: null,
      label: "Select Client...",
    })
    if (filter) {
      handleFilter("clear")
    }
    setFilter(null)
  };

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle);
        if (!filter) {
          setClientSelected({
            value: null,
            label: "Select..",
          })
          setFilter(null)
        }
      }}
    >
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={
          <Tooltip id="button-view-download-invoice">
            Filter
          </Tooltip>
        }
      >
        <DropdownToggle
          caret
          color="secondary"
          style={
            toggle || !clientSelected?.value
              ? { border: "1px solid#bfcbe1" }
              : {
                color: "#dd4433",
                border: "1px solid #dd4433",
                backgroundColor: "#fff6f5",
              }
          }
          outline
        >
          <img src={toggle ? FilterIcon : filterBlackIcon} alt="" />

        </DropdownToggle>
      </OverlayTrigger>
      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
                if (!filter) {
                  setClientSelected({
                    value: null,
                    label: "Select..",
                  })
                  setFilter(null)
                }
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          <div className="mt-4 ml-1">
            <label className='mb-1'>Select Client</label>
            <div>
              <Select
                value={clientSelected}
                cacheOptions
                options={finalClientList}
                onChange={handleChangeClient}
                onMenuScrollToBottom={(e: any) => checkBottom(e)}
                onInputChange={(e: string) => {
                  setLoadCondition(false);
                  setText(e);
                  setOffset(0);
                }}
                onMenuClose={onMenuClose}
                isLoading={loadCondition && clientDirectoryFetching}
              />
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end p-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
            disabled={!clientSelected?.value}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
            disabled={!clientSelected?.value}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  )
}

export default AllClientScheduleFilter
